import React from "react";
import "./HeroPostLaunch.css";
import { TranslationsMap } from "../../pages/CountryPage/CountryPage";
import logoMobile from "../../assets/logo/horizontal-small-white.svg";
import logoDesktop from "../../assets/logo/horizontal-large.svg";
import AppDownload from "../AppDownload/AppDownload";

interface IntroProps {
  translations: TranslationsMap;
}

const HeroPostLaunch: React.FC<IntroProps> = ({ translations }) => {
  return (
    <div className="hero-container">
      <div className="hero-content">
        <div>
          <div className="display-mobile">
            <img alt="Logo" src={logoMobile} />
          </div>
          <div className="display-desktop">
            <img alt="Logo" src={logoDesktop} />
          </div>
        </div>
        <div>
          <h1 className="mb-2 hero-head">
            {translations["landingPage.hero.title"]}
          </h1>
          <p className="mb-6 hero-subtitle">
            {translations["landingPage.hero.body"]}
          </p>
          <AppDownload />
        </div>
        <div className="display-desktop flex-grow" />
      </div>
    </div>
  );
};

export default HeroPostLaunch;
